import modalConfirmation from '../shared/components/modal-response/modal-response.view.html';
import modalMap from '../shared/components/modal-map/modal-map.view.html';
import modalProductComment from './product-comment-modal/product-comment-modal.view.html';
import modalCreateTemplate from './create-template-modal/create-template-modal.view.html';
import modalLogistic from './modal-logistic/modal-logistic.view.html';
import modalCartComment from './modal-comment-cart/modal-comment-cart.view.html';
let inject = [
  '$scope',
  'CartService',
  '$state',
  '$rootScope',
  'SharedService',
  '$uibModal',
  'ngAuthSettings',
  'SessionService',
  '$timeout',
  '$filter'
];

class CartController{
  constructor ($scope, CartService, $state, $rootScope, SharedService, $uibModal, ngAuthSettings, SessionService, $timeout, $filter) {
    this.$state = $state;
    this.ngAuthSettings = ngAuthSettings;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$filter = $filter;
    this.$rootScope = $rootScope;
    this.$uibModal = $uibModal;
    this.SessionService = SessionService;
    this.CartService = CartService;
    this.SharedService = SharedService;
    this.loanding = false;
    this.orderDataForm = {
      country: '',
      state: '',
      city: '',
      shipping: 0,
      payment: '',
      comment: '',
      clientPriceList: ''
    };
    this.quoteCartSeller = {
      realOrderInfo: {},
      realQuoteInfo: {}
    };
    this.orderDataForm.locationsByFastSearch = [];
    this.orderDataForm.locationSelected = false;
    this.orderDataForm.searchLocationtext = '';
    this.orderDataForm.loadingLocationsByFastSearh = false;
    this.orderDataForm.loadedLocationsByFastSearch = false;
    this.orderDataForm.errorLoadingLocationsByFastSearch = false;
    this.quoteCartSeller.subtotalItemsQuoteValueSeller = 0;
    this.quoteCartSeller.discountsItemsQuoteValueSeller = 0;
    this.quoteCartSeller.ivaItemsQuoteValueSeller = 0;
    this.quoteCartSeller.transportItemsQuoteValueSeller = 0;
    this.quoteCartSeller.totalItemsQuoteValueSeller = 0;
    this.pesoTotalCanasta = 0;
    this.cantidadTotalCanasta = 0;
    this.updatingCityLocation = false;
    this.updatedCityLocation = false;
    this.errorUpdatingCityLocation = false;
    this.pointsOfSaleData = [];
    this.pointOfSaleId = '';
    this.currentPointOfSale = '';
    this.loadingPointsOfSale = false;
    this.loadedPointsOfSale = false;
    this.savingPayMethodCart = false;
    this.errorUpdatingPayMethod = false;
    this.addingQuantityItemCart = false;
    this.addedQuantityItemCart = false;
    this.errorAddingQuantityItemtoCart = false;
    this.errorMessageAddingQuantityItemtoCart = '';
    this.errorMessagesAddingQuantityItemtoCart = '';
    this.coupon = {};
    this.coupon.savingCoupon = false;
    this.coupon.savedCoupon = false;
    this.coupon.validCoupon = false;
    this.orderDataForm.loadingCartInfo = false;
    this.orderDataForm.loadedCartInfo = false;
    this.loadedPayMethods = false;

    this.cart = {};

    this.$rootScope.$on('onUpdateCart', (event, arg) => {
      this.updateCart();
    });
  }

  $onInit(){
    let cartId = this.SessionService.get('cartId') || '';
    let userId = '';
    try{ userId = this.shCtrl.globals.currentUser.userId; }
    catch(e){}
    let clientPriceListName = '';
    try {
      clientPriceListName = this.SessionService.get('quoteCartSeller').clientPriceList;
    } catch(e) {}
    this.CartService.getCart(cartId, userId, clientPriceListName, true).then(response => {
      this.cart = response;
      this.getAllCartOrderInfo();
      // Get the bill resume
      try {
        if (this.shCtrl.globals.currentClient.third) {
          this.getInfoBillfoldState();
        }
      }
      catch (e) {
      }
    }).catch(() => {
      this.$state.go(this.ngAuthSettings.site.app.header.logo.url);
    });

  }

  getAllCartOrderInfo () {
    this.orderDataForm.loadingCartInfo = true;
    this.orderDataForm.loadedCartIfno = false;
    let cart = angular.copy(this.shCtrl.cart);
    if (cart) {
      let sellerId = '';
      try {
        sellerId = this.shCtrl.globals.currentUser.sellerId;
      }
      catch (e) {
      }

      let userId = '';
      try {
        userId = this.shCtrl.globals.currentUser.userId;
      }
      catch (e) {
      }

      this.CartService.getPayMethods(sellerId, userId).then(response => {
        if (!this.orderDataForm.pointOfSaleId) {
          this.loadedPayMethods = true;
          this.payMethods = response;
          if(response.length === 1){
            this.orderDataForm.payment = response[0].id;
          }
        }
        this.CartService.getPointsOfSale().then(response2 => {
          if (!this.orderDataForm.pointOfSaleId) {
            this.loadedPointsOfSale = true;
            this.pointsOfSaleData = response2.operatingCenters;
          }
          this.$timeout(() => {
            // Set the default Point of Sale
            let pointOfSaleId = this.shCtrl.cart.order.pointOfSale.id;
            if (pointOfSaleId) {
              this.orderDataForm.pointOfSaleId = pointOfSaleId.toString();
              this.setCurrentPointOfSale(this.orderDataForm.pointOfSaleId);
            }
            else if (this.pointsOfSaleData.length === 1) {
              this.orderDataForm.pointOfSaleId = this.pointsOfSaleData[0].id.toString();
              this.setCurrentPointOfSale(this.orderDataForm.pointOfSaleId);
            }

            if (!this.orderDataForm.shipping && this.shCtrl.cart.order.shippingId) {
              this.orderDataForm.shipping = this.shCtrl.cart.order.shippingId.toString();
            }
            if (!this.orderComment && this.shCtrl.cart.order.comment) {
              this.orderComment = this.shCtrl.cart.order.comment.toString();
            }
            if (!this.orderDataForm.comment && this.shCtrl.cart.order.comment) {
              this.orderDataForm.comment = this.shCtrl.cart.order.comment.toString();
            }

            if (!this.orderDataForm.payment && this.shCtrl.cart.order.payment.id) {
              this.orderDataForm.payment = this.shCtrl.cart.order.payment.id.toString();
            }
            else if (this.payMethods.length === 1) {
              this.orderDataForm.payment = this.payMethods[0].id.toString();
            }

            // Set the city
            try {
              if (this.shCtrl.cart.order.location.city.id) {
                this.orderDataForm.city = this.shCtrl.cart.order.location.city.id;
                this.orderDataForm.state = this.shCtrl.cart.order.location.state.id;
                this.orderDataForm.country = this.shCtrl.cart.order.location.country.id;

                this.orderDataForm.searchLocationtext = this.shCtrl.cart.order.location.city.name + ', ';
                this.orderDataForm.searchLocationtext += this.shCtrl.cart.order.location.state.name + ', ';
                this.orderDataForm.searchLocationtext += this.shCtrl.cart.order.location.country.name;
              }
            }
            catch (e) {
            }
          }, 1000);
        }).catch(reason => {

        });
      }).catch(reason => {

      });
    }
    this.orderDataForm.loadingCartInfo = false;
    this.orderDataForm.loadedCartInfo = true;
  }

  getInfoBillfoldState () {

    try {
      this.loadingBillResume = true;
      let thirdDocumentNumber = this.shCtrl.globals.currentClient.third.documentNumber;
      let branchCode = this.shCtrl.globals.currentClient.operatingCenter.code;
      this.CartService.getInfoBillfoldState(
        thirdDocumentNumber,
        branchCode
      )
        .then(billfoldResume => {
          this.billfoldResume = billfoldResume;
          this.loadingBillResume = false;
          this.loadedBillResume = true;
          this.lastUpdatedBillResume = this.$filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
        })
        .catch(error => {
          this.loadingBillResume = false;
        });

    }
    catch (e) {
      // ...
    }
  }

  buyNow (form, allowGuestInTunnel) {
    if(allowGuestInTunnel === 'register'){
      this.$state.go('home.login');
      return;
    }
    this.$rootScope.allowGuestInTunnel = allowGuestInTunnel || 0;
    this.showAllCartErrors = false;
    if (form.$valid) {
      if (this.cart) {
        let itemWithOutStock = this.cart.items.filter(value => {
          if (value.quantity > value.cantidad) {
            return value;
          }
        });
        if (itemWithOutStock.length) {
          let cartItemHtml = '';
          itemWithOutStock.forEach(val => {
            cartItemHtml += `
              <li>
                <strong>- Producto: </strong> ${val.name} -
                <strong>Cantidad: </strong>${val.cantidad} Unidades
              </li>`;
          });
          let mensaje = `
            <span>Lo Sentimos, Algunos productos exceden la cantidad dispobible<strong>
            <ul>
              ${cartItemHtml}
            </ul>
            Por favor elimine el excedente.</span>`;
          let options = {
            title : 'Cantidad no disponible',
            isHtml : true,
            content : mensaje,
            size : '',
            showBottonCancel : false,
            textActionCancel : '',
            textAction : 'Aceptar'
          };
          return this.messageResponse(options);
        }
      }
      if (this.cart.cartId) {
        this.savingOrderCart = true;
        this.savedOrderCart = false;
        this.errorSavingOrderCart = false;
        this.orderDataForm.cartId = this.cart.cartId;
        this.orderDataForm.userId = '';
        this.orderDataForm.sellerId = '';
        try {
          this.orderDataForm.userId = this.shCtrl.globals.currentUser.userId;
        }
        catch (e) {
        }
        try {
          this.orderDataForm.sellerId = this.shCtrl.globals.currentUser.sellerId;
        }
        catch (e) {
        }
        this.CartService.saveCartOrderData(this.orderDataForm).then(response => {
          this.savingOrderCart = false;
          if(!response.error) {
            this.savedOrderCart = true;
            this.$state.go('home.tunnel');
          } else {
            let errorMessageSavingOrderCart = response.message;
            this.errorSavingOrderCart = true;
            let messageTitle = response.errorCode === 'EVMP' ? 'El pedido no puede ser procesado' : 'Debes diligenciar algunos datos aún...';
            let options = {
              title : messageTitle,
              isHtml : true,
              content : errorMessageSavingOrderCart,
              size : '',
              showBottonCancel : false,
              textActionCancel : '',
              textAction : 'Aceptar'
            };
            this.messageResponse(options);
          }
        }).catch(reason => {
          this.savingOrderCart = false;
          this.savedOrderCart = false;
          this.errorSavingOrderCart = true;
          let options = {
            title : '',
            isHtml : false,
            content : 'Ha ocurrido un error al actualizar la informacion del carrito',
            size : '',
            showBottonCancel : false,
            textActionCancel : '',
            textAction : 'Aceptar'
          };
          this.messageResponse(options);
        });
      }
    } else {
      this.showAllCartErrors = true;
      angular.forEach(form.$error.required, field => {
        field.$setDirty();
      });
      if(!this.orderForm.searchLocationtext) this.orderForm.searchLocationtext = {};
      if(!this.orderForm.payment) this.orderForm.payment = {};
      if(!this.orderForm.clientPriceList) this.orderForm.clientPriceList = {};
      let contentDynamic = '';
      if(this.orderForm.searchLocationtext.$invalid && !this.orderForm.searchLocationtext.$pristine){
        contentDynamic =  `
          <li>
            Seleccione la Ciudad.
          </li>`;
      }
      if(this.orderForm.payment.$invalid && !this.orderForm.payment.$pristine){
        contentDynamic +=  `
          <li>
            Seleccione el medio de pago.
          </li>`;
      }
      if(this.orderForm.clientPriceList.$invalid && !this.orderForm.clientPriceList.$pristine){
        contentDynamic +=  `
          <li>
            Seleccione la lista de precios a aplicar al cliente.
          </li>`;
      }
      let options = {
        title : 'Faltan algunos datos por diligenciar...',
        isHtml : true,
        content : `
          <div>
            <p>
              Para continuar con este proceso debes diligenciar los siguientes datos:
            </p>
            <ul style="margin-top: 10px;list-style: inherit;margin-left: 30px;">
              ${contentDynamic}
            </ul>
          </div>
        `,
        size : '',
        showBottonCancel : false,
        textActionCancel : '',
        textAction : 'Aceptar'
      };
      this.messageResponse(options);
    }
  }

  showProductComment(item){
    let modal_options = this.$uibModal.open({
      animation: true,
      template: modalProductComment,
      controller : 'ProductCommentModalController',
      controllerAs : 'mdCtrl',
      size: '',
      resolve : {
        modalOptions : () => item
      }
    });
    modal_options.result.then(() => {

    }).catch(reason => {

    });
  }

  getLocationsByFastSearch(searchLocationText) {
    this.orderDataForm.locationSelected = false;
    this.orderDataForm.locationsByFastSearch = [];
    this.orderDataForm.locationSelected = false;
    this.orderDataForm.country = '';
    this.orderDataForm.state = '';
    this.orderDataForm.city = '';
    this.orderDataForm.loadingLocationsByFastSearh = false;
    this.orderDataForm.loadedLocationsByFastSearch = false;
    this.orderDataForm.errorLoadingLocationsByFastSearch = false;
    if (searchLocationText.length > 3) {
      this.orderDataForm.loadingLocationsByFastSearh = true;
      this.CartService.locationBySearchText({
        'searchText': searchLocationText,
        'showOnlyValidCountries': 1,
        'showOnlyCitiesInTransportRule': 1
      }).then(response => {
        this.orderDataForm.loadingLocationsByFastSearh = false;
        this.orderDataForm.loadedLocationsByFastSearch = true;
        this.orderDataForm.locationsByFastSearch = response;
      }).catch(reason => {
        this.orderDataForm.loadingLocationsByFastSearh = false;
        this.orderDataForm.loadedLocationsByFastSearch = true;
        this.orderDataForm.errorLoadingLocationsByFastSearch = true;
      });
    }
  }

  setLocationCity(location) {
    this.orderDataForm.country = location.countryId;
    this.orderDataForm.state = location.stateId;
    this.orderDataForm.city = location.cityId;

    this.orderDataForm.locationSelected = true;
    this.orderDataForm.searchLocationtext = location.cityName + ', ' +
      location.stateName + ' - ' +
      location.countryName;
    this.updateCityLocation();
  }

  updateValuesQuoteSeller() {
    if (!this.orderDataForm.clientPriceList) {
      try {
        this.orderDataForm.clientPriceList = this.SessionService.get('quoteCartSeller').clientPriceList;
      }
      catch (e) {
      }

      if (!this.orderDataForm.clientPriceList) {
        this.orderDataForm.clientPriceList = 'client';
      }
    }
    this.quoteCartSeller.subtotalItemsQuoteValueSeller = 0;
    this.quoteCartSeller.ivaItemsQuoteValueSeller = 0;
    this.quoteCartSeller.discountsItemsQuoteValueSeller = 0;
    this.quoteCartSeller.transportItemsQuoteValueSeller = 0;
    this.quoteCartSeller.totalItemsQuoteValueSeller = 0;

    let realOrderInfo = {
      subtotal: 0,
      iva: 0,
      discount: 0,
      transport: 0,
      total: 0
    };

    let realQuoteInfo = {
      subtotal: 0,
      iva: 0,
      discount: 0,
      transport: 0,
      total: 0
    };
    if (this.shCtrl.globals.currentUser.isSeller) {
      // Se actualiza la informacion de los precios
      let itemsQuoteCartSeller = [];
      let priceListName = this.orderDataForm.clientPriceList;

      let subtotal = 0;
      let taxes = 0;
      let discounts = 0;
      let total = 0;
      this.cart.items.forEach((item, key) => {
        try {
          // Item data
          let itemId = item.id;
          let itemQuantity = item.quantity;
          let itemUnitValue = item.priceItemQuoteSeller;
          let itemQuantityValue = item.quantity * item.priceItemQuoteSeller;
          let itemTaxPercent = item.ivaPercentageQuoteSeller;
          let itemDiscountPercent = item.discountPercentageItemQuoteSeller;
          // Some verifications
          if (isNaN(itemDiscountPercent) || itemDiscountPercent < 0 || itemDiscountPercent > 100) {
            item.discountPercentageItemQuoteSeller = 0;
            itemDiscountPercent = 0
          }
          else if (priceListName === 'client' && itemDiscountPercent > item.maxDiscount) {
            item.discountPercentageItemQuoteSeller = item.maxDiscount;
            itemDiscountPercent = item.maxDiscount;
          }
          else if (priceListName === 'cost' && itemDiscountPercent > 100) {
            item.discountPercentageItemQuoteSeller = 100;
            itemDiscountPercent = 100;
          }

          // Item values
          let itemSubtotal = itemQuantityValue;
          let itemDiscount = 0;

          if (priceListName === 'client') {
            itemDiscount = itemQuantityValue * itemDiscountPercent / 100;
          }
          if (priceListName === 'cost') {
            itemDiscount = itemQuantityValue / ((100 - itemDiscountPercent) / 100);
            itemDiscount = itemDiscount - itemQuantityValue;
          }
          // Discount or Profit?
          let itemQuantityValueWithDiscount = 0;
          if (priceListName === 'client') {
            itemQuantityValueWithDiscount = itemQuantityValue - itemDiscount;
          }
          if (priceListName === 'cost') {
            itemQuantityValueWithDiscount = itemQuantityValue + itemDiscount;
          }
          let itemTax = itemQuantityValueWithDiscount * itemTaxPercent / 100;
          let itemTotal = itemQuantityValueWithDiscount + itemTax;

          // Totals
          subtotal += itemQuantityValue;
          discounts += itemDiscount;
          taxes += itemTax;
          total += itemTotal;

          // Update the item total model
          this.cart.items[key].totalItemCartSeller = itemTotal;

          // ========================================================================================================================
          // Real quote values
          // ========================================================================================================================
          if (item.quote) {
            realQuoteInfo.subtotal += itemQuantityValue;
            realQuoteInfo.iva += itemTax;
            realQuoteInfo.discount += itemDiscount;
            if (priceListName === 'client') {
              realQuoteInfo.total = realQuoteInfo.subtotal - realQuoteInfo.discount + realQuoteInfo.iva;
            }
            else if (priceListName === 'cost') {
              realQuoteInfo.total = realQuoteInfo.subtotal + realQuoteInfo.discount + realQuoteInfo.iva;
            }
          }
          // ========================================================================================================================
          // Real order values
          // ========================================================================================================================
          else {
            realOrderInfo.subtotal += itemQuantityValue;
            realOrderInfo.iva += itemTax;
            realOrderInfo.discount += itemDiscount;

            if (priceListName === 'client') {
              realOrderInfo.total = realOrderInfo.subtotal + realOrderInfo.iva - realOrderInfo.discount;
            }
            else if (priceListName === 'cost') {
              realOrderInfo.total = realOrderInfo.subtotal + realOrderInfo.iva + realOrderInfo.discount;
            }
          }

          // ========================================================================================================================
          // Push data to the cart seller object
          // ========================================================================================================================
          itemsQuoteCartSeller.push({
            id: item.id,
            priceItemQuoteSeller: itemUnitValue,
            ivaPercentageQuoteSeller: itemTaxPercent,
            discountPercentageItemQuoteSeller: itemDiscountPercent,
            discountValueItemQuoteSeller: itemDiscount
          });
        }
        catch (e) {
          let options2 = {
            title : '',
            isHtml : false,
            content : e,
            size : '',
            showBottonCancel : false,
            textActionCancel : '',
            textAction : 'Aceptar'
          };
          this.messageResponse(options);
        }

        try {
          // Update the model
          this.quoteCartSeller.subtotalItemsQuoteValueSeller = subtotal;
          this.quoteCartSeller.ivaItemsQuoteValueSeller = taxes;
          this.quoteCartSeller.discountsItemsQuoteValueSeller = discounts;
          this.quoteCartSeller.transportItemsQuoteValueSeller = $rootScope.cartTransports;
          this.quoteCartSeller.totalItemsQuoteValueSeller = total + $rootScope.cartTransports;

          this.quoteCartSeller.realOrderInfo.transport = $rootScope.cartTransports;
          this.quoteCartSeller.realOrderInfo.total += +$rootScope.cartTransports;
          this.quoteCartSeller.realOrderInfo = realOrderInfo;

          this.quoteCartSeller.realQuoteInfo.transport = $rootScope.cartTransports;
          this.quoteCartSeller.realQuoteInfo.total += +$rootScope.cartTransports;
          this.quoteCartSeller.realQuoteInfo = realQuoteInfo;
          // save data state to cookie
          this.SessionService.put('quoteCartSeller', {
            clientPriceList: priceListName,
            itemsQuoteCartSeller: itemsQuoteCartSeller,
            subtotalItemsQuoteValueSeller: subtotal,
            ivaItemsQuoteValueSeller: taxes,
            discountsItemsQuoteValueSeller: discounts,
            totalItemsQuoteValueSeller: this.quoteCartSeller.totalItemsQuoteValueSeller,
            realOrderInfo: realOrderInfo,
            realQuoteInfo: realQuoteInfo
          });
        }
        catch (e) {
          let options = {
            title : '',
            isHtml : false,
            content : e,
            size : '',
            showBottonCancel : false,
            textActionCancel : '',
            textAction : 'Aceptar'
          };
          this.messageResponse(options);
        }

      });
    }
    this.updateCart();
  }

  setCurrentPointOfSale(pointOfSaleId) {
  this.pointsOfSaleData.forEach(pointOfSale => {
      if (pointOfSale.id === pointOfSaleId) {
        this.currentPointOfSale = pointOfSale;
      }
    });
  }

  savePayMethodCart (payMethodId) {
    if (payMethodId) {
      this.savingPayMethodCart = true;
      this.errorUpdatingPayMethod = false;
      let data = {
        'cartId': this.cart.cartId,
        'payMethodId': payMethodId
      };
      this.CartService.updatePayMethod(data).then(response => {
        if (!response.error) {
          this.savingPayMethodCart = false;
          this.updateCart();
        }
        else {
          this.savingPayMethodCart = false;
          this.errorUpdatingPayMethod = true;
          this.orderDataForm.payment = '';
        }
      }).catch(reason => {
        this.savingPayMethodCart = false;
        this.errorUpdatingPayMethod = true;
      });
    }
  }

  changeLogisticService (value) {
    if(!value) {
      this.selectGuestUser();
    } else {
      this.guestUser = {};
    }
  };

  selectGuestUser () {
    let modalInstance = this.$uibModal.open({
      animation: true,
      backdrop : 'static',
      template: modalLogistic,
      controller: 'GuestUserController',
      controllerAs: 'mdCtrl',
      resolve: {
        optionsModal: () => {
          return this.guestUser;
        }
      }
    });
    modalInstance.result.then(resultUser => {
      this.guestUser = resultUser;
    }).catch(errModal => {
      this.isLogisticService = true;
    });
  }

  saveDiscountCoupon (code) {
    this.coupon.savingCoupon = true;
    this.coupon.savedCoupon = false;
    if (code === 'DESC14') {
      this.$timeout(() => {
        this.coupon.savingCoupon = false;
        this.coupon.couponSaved = true;

        this.coupon.validCoupon = true;
        this.coupon.couponValue = 10000;
      }, 3000);
    }
    else {
      this.$timeout(() => {
        this.coupon.discountCoupon = '';

        this.coupon.savingCoupon = false;
        this.coupon.couponSaved = true;

        this.coupon.validCoupon = false;
        this.coupon.couponValue = 0;
      }, 3000);
    }
  }

  updateCityLocation() {
    let cityLocationId = this.orderDataForm.city;
    this.updatingCityLocation = true;
    this.updatedCityLocation = false;
    this.errorUpdatingCityLocation = false;
    if (this.cart.cartId && cityLocationId) {
      this.CartService.updateCityLocation({
        'cartId': this.cart.cartId,
        'cityLocationId': cityLocationId
      }).then(response => {
        this.updatingCityLocation = false;
        this.updatedCityLocation = false;
        if (response.error) {
          this.errorUpdatingCityLocation = true;
        }
      }).catch(reason => {
        this.updatingCityLocation = false;
        this.updatedCityLocation = true;
        this.errorUpdatingCityLocation = true;
      });

    }
  }

  saveItemQuantity(product) {
    this.addingQuantityItemCart = true;
    this.addedQuantityItemCart = false;
    this.errorAddingQuantityItemtoCart = false;
    this.errorMessageAddingQuantityItemtoCart = '';
    this.errorMessagesAddingQuantityItemtoCart = '';

    if (isNaN(product.quantityToAddFromCart) || product.quantityToAddFromCart < 1) {
      product.quantityToAddFromCart = product.quantity;
      return false;
    }

    if (product.quantity !== product.quantityToAddFromCart) {
      /* Si la cantidad a agregar del producto es mayor a la cantidad disponible del mismo le indica al
       * usuario que hacer al respecto */
      // if (quantity > product.cantidad){
      if (product.quantityToAddFromCart > product.cantidad){
        let mensaje = `
          <span>Lo Sentimos, El producto <strong> ${product.name} </strong>
          no está disponible en la cantidad solicitada. La existencia actual de este producto es
          <strong>${product.cantidad}</strong> Unidades</span>`;
        product.quantityToAddFromCart = product.quantity;
        let options = {
          title : 'Cantidad no disponible',
          isHtml : true,
          content : mensaje,
          size : '',
          showBottonCancel : false,
          textActionCancel : '',
          textAction : 'Aceptar'
        };
        return this.messageResponse(options);

      }

      let data = {
        'cartId': this.cart.cartId,
        'productId': product.id,
        'productQuantity': product.quantityToAddFromCart
      };

      if (this.cart.cartId) {
        this.CartService.updateQuantityItemCart(data).then(response => {
          this.addingQuantityItemCart = false;
          if (!response.error) {
            this.updateCart();
          }
          else {
            product.quantityToAddFromCart = product.quantity;
            this.errorAddingQuantityItemtoCart = true;
            this.errorMessageAddingQuantityItemtoCart = response.message;
          }
        }).catch(reason => {
          this.addingQuantityItemCart = false;
          product.quantityToAddFromCart = product.quantity;
          let options = {
            title : '',
            isHtml : false,
            content : 'Ha ocurrido un error al actualizar el carrito',
            size : '',
            showBottonCancel : false,
            textActionCancel : '',
            textAction : 'Aceptar'
          };
          this.messageResponse(options);
        });
      }
    }
    else {
      this.addingQuantityItemCart = false;
      product.quantityToAddFromCart = product.quantity;
    }
  };

  createTemplate(){
    let options = {
      globals : this.shCtrl.globals
    };
    let modal_options = this.$uibModal.open({
      animation: true,
      template: modalCreateTemplate,
      controller : 'CreateTemplateModalController',
      controllerAs : 'mdCtrl',
      size: '',
      resolve : {
        modalOptions : () => options
      }
    });
    modal_options.result.then(() => {

    }).catch(reason => {

    });
  }

  calcularTotales (){
    this.pesoTotalCanasta = 0;
    this.cantidadTotalCanasta = 0;
    this.cart.order.totalPesoItems = 0;
    this.cart.order.cantidadTotalCanasta = 0;
    this.cart.items.forEach(item => {
      this.pesoTotalCanasta += item.quantityToAddFromCart*item.peso.embalaje;
      this.cantidadTotalCanasta += item.quantityToAddFromCart;
      this.cart.order.totalPesoItems += item.quantityToAddFromCart*item.peso.embalaje;
      this.cart.order.cantidadTotalCanasta += item.quantityToAddFromCart;
    });
  }

  setCartSellerAction (form) {
    if (form.$valid) {
      let userIsLogged = false;
      try {
        userIsLogged = this.shCtrl.globals.currentUser.isLogged;
      }
      catch (e) {

      }
      // ===========================================================================================================
      // Logged client
      // ===========================================================================================================
      if (userIsLogged) {
        if (this.orderDataForm.quoteCartSellerAction === 'quote') {
          this.showModalCartSeller();
        }
        else if (this.orderDataForm.quoteCartSellerAction === 'order') {

          // If there is no client selected
          if (this.shCtrl.globals.currentUser.userId === this.shCtrl.globals.currentUser.sellerId) {
            this.showModalCartSeller();
          }
          else {
            this.buyNow(form);
          }
        }
      }
      else {
        this.showModalCartSeller();
      }
    }
    else {
      this.showAllCartErrors = true;

      angular.forEach(form.$error.required, field => {
        field.$setDirty();
      });
    }
  }

  showModalCartSeller () {
    // Always open the step 1

    // Validate the third number to restart all the info
    // let thirdNumberIb = $('#modalQuoteSeller #sellerQuoteAttendantDocumentNumber').val();
    // if (thirdNumberIb) {
    //   this.validateNumberIdUnused(thirdNumberIb);
    // }
  };

  openCartComment(){
    let options = {
      comment : this.orderComment
    };
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalCartComment,
      controller : 'CommentCartModalController',
      controllerAs : 'mdCtrl',
      size: '',
      resolve : {
        modalOptions : () => options
      }
    });
    modalInstance.result.then(comment => {
      this.orderDataForm.comment = comment;
      this.orderComment = comment;
    }).catch(reason => {

    });
  }

  removeItemFromCart (product) {
    let options = {
      title : `ELIMINAR PRODUCTO <b>${product.name}</b>`,
      isHtml : true,
      titleIsHtml: true,
      content : `¿En realidad desea eliminar del carrito el producto <b>${product.name}</b>?`,
      showBottonCancel : true,
      textActionCancel : 'Cancelar',
      textAction : 'Aceptar'
    };
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller : 'ModalResponseController',
      controllerAs : 'mdCtrl',
      size: '',
      resolve : {
        modalOptions : () => options
      }
    });
    modalInstance.result.then(() => {
      this.confirmRemoveItem(product.id, product);
    }).catch(() => {

    });
  }

  confirmRemoveItem(productId, product){
    if (this.cart.cartId) {
      this.deletingItemCart = true;
      this.deletedItemCart = false;
      this.errorDeletedItemCart = false;
      this.CartService.deleteItemFromCart(productId, this.cart.cartId).then(response => {
        this.deletingItemCart = false;
        if (!response.error) {
          this.deletedItemCart = true;
          this.updateCart();
          let options = {
            title : 'Notificación',
            isHtml : true,
            content : `<div class="alert alert-success" style="margin-bottom: 10px;">
              El producto <b>${product ? product.name : ''}</b> ha sido eliminado del carrito.
            </div>`,
            size : 'sm',
            showBottonCancel : false,
            textActionCancel : '',
            textAction : 'Aceptar'
          };
          this.messageResponse(options);
        }
        else {
          this.errorDeletedItemCart = true;
        }
      }).catch(error => {
        this.deletingItemCart = false;
        this.deletedItemCart = false;
        this.errorDeletedItemCart = true;
      });
    }
  }

  openMap(branch){
    let options = {
      center : {
        latitude  : branch.latitude,
        longitude : branch.longitude
      },
      zoom: 15,
      pan : true
    };
    let modal_options = this.$uibModal.open({
      animation: true,
      template: modalMap,
      controller : 'ModalMapController',
      controllerAs : 'mdCtrl',
      size: '',
      resolve : {
        modalOptions : () => options
      }
    });
    modal_options.result.then(() => {

    }).catch(reason => {

    });
  }

  updateCart() {
    let cartId = this.SessionService.get('cartId') || '';
    let userId = '';
    try{ userId = this.shCtrl.globals.currentUser.userId; }
    catch(e){}
    let clientPriceListName = '';
    try {
      clientPriceListName = this.SessionService.get('quoteCartSeller').clientPriceList;
    } catch(e) {}
    this.CartService.getCart(cartId, userId, clientPriceListName, true).then(response => {
      this.cart = response;
      this.$scope.$emit('onUpdateCart');
    }).catch(() => {
      this.$state.go(this.ngAuthSettings.site.app.header.logo.url);
    });
  }

  clearCart () {
    // Delete cart
    let data = {
      'cartId': this.cart.cartId
    };
    this.CartService.clearCart(data).then(response => {
      if (!response.error) {
        this.cart = {};
        this.SessionService.put('cartId', '');
        this.SessionService.remove('quoteCartSeller');
        this.$scope.$emit('onUpdateCart');
        this.updateCart();
      }
      else {
        let options = {
          title : '',
          isHtml : false,
          content : response.message,
          size : '',
          showBottonCancel : false,
          textActionCancel : '',
          textAction : 'Aceptar'
        };
        this.messageResponse(options);
      }
    }).catch(reason => {
      let options = {
        title : '',
        isHtml : false,
        content : reason,
        size : '',
        showBottonCancel : false,
        textActionCancel : '',
        textAction : 'Aceptar'
      };
      this.messageResponse(options);
    });
  }

  messageResponse (options, callAcept, callback, callCancel, callbackCancel) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller : 'ModalResponseController',
      controllerAs : 'mdCtrl',
      size: options.size,
      resolve : {
        modalOptions : () => options
      }
    });
    modalInstance.result.then(() => {
      if(callAcept) {
        callback();
      }
    }).catch(reason => {
      if(callCancel) {
        callbackCancel();
      }
    });
  }
}

CartController.$inject = inject;

export default CartController;




/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/cart/cart.controller.js
 **/